export default __webpack_public_path__ + "static/media/luisa.a7ac57f7.png";